import React from "react"
import "./style.scss"
import Layout from "../../../components/layout/layout"
import tss from "../../../images/tss.svg"
import tWorldwide from "../../../images/tWorldwide.svg"
import drivex from "../../../images/drivex.svg"
import bannerImage from "./banner.svg"
import ServiceHeader from "../../../components/serviceCards/serviceHeader"
import OverviewSection from "../../../components/serviceCards/overviewSection"
import ServicesSection from "../../../components/serviceCards/servicesSection"
import PointsSection from "../../../components/serviceCards/pointsSection"
import BookingSection from "../../../components/serviceCards/bookingSection"
import CustomerSection from "../../../components/serviceCards/customerSection"
import RelatedArticles from "../../../components/cards/relatedarticles/RelatedArticles"
import { graphql } from "gatsby"
import SEO from "../../../components/seo"

const MarketplaceMonitoring = ({ data, location: { pathname } }) => {
  const datas = {
    title:
      "Prevent marketplace infringement with our market monitoring services.",
    text:
      "Accurate market monitoring and legit enforcement services for your business to maintain its supremacy in the marketplace. ",
    overviewTitle: "Overview - Market Monitoring Service",
    overviewText: [
      "Online marketplaces are very prone to illicit counterfeit product sales and IP (intellectual property) infringement. Despite being a punishable offense, many sellers and online marketplace owners indulge in selling fake products through dubious websites. And yet, many analytics companies fail to provide solution-oriented services to enterprises to counter these issues. Therefore, Wersel believes in providing explicitly reinforced and highly effective marketplace monitoring services to its clients.",
      <br />,
      <br />,
      "At Wersel, we house the teams of highly proficient and seasoned analysts who know how to safeguard and monitor your brand in the highly dynamic marketplace. We adhere to a highly accurate product review mechanism to validate the IP infringement to ensure that your brand reputation remains intact.",
      <br />,
      <br />,
      "Our marketplace monitoring services revolve around eliminating the reputation, legal, and financial risks that may come following an IP infringement incident. How do we do it? By continually monitoring the sellers, web domains, and product listings in the vital marketplace. We also employ a multidirectional approach and analyze the subtle components like imagery, product descriptions, customer review, sale return rate, etc., to identify potential infringements.",
    ],
    serviceSubtitle:
      "Our highly agile and client-centric market monitoring services enable enterprises to maximize the respective market share and enhance revenue generation by eliminating counterfeit products/ services from key marketplaces. Here are the salient features of our marketplace monitoring services- ",
    services: [
      {
        title: "Trademark Protection",
        content:
          "We monitor the key marketplaces for unauthorized intellectual property usage. We incorporate the use of highly intelligent software to detect the illegitimate use of your brand's logo, copyrighted imagery, patents, rogue website, and pirated content and protect the trademark property of your brand.",
      },
      {
        title: "Safeguard Web Traffic",
        content:
          "Our experts monitor the online market space for malicious practices intended to divert your user traffic through counterfeit websites and black-hat SEO techniques.",
      },
      {
        title: "Protect Consumers",
        content:
          "We thoroughly monitor online marketplaces to identify and eliminate counterfeit goods to maintain your brand's credibility and offer authentic products to consumers.",
      },
      {
        title: "Grow and Safeguard Revenue",
        content:
          "The counterfeit websites and duplicate products puncture your streamlined revenue; we detect and prevent infringement issues from curbing revenue theft.",
      },
      {
        title: "Tactical Enforcement ",
        content:
          "The key to eliminating infringement and counterfeit issues is identifying, designing, and enforcing preventive action against the root cause of infringement.",
      },
    ],
    whyPartnerWerselTitle: "Why Partner with Wersel Workdesk?",
    whyPartnerWerselText:
      "Wersel houses teams of highly qualified personnel to monitor the marketplace for your brand. We give utmost importance to identify and comprehend the counterfeit issues. And after validating the counterfeit product/ service, we deploy the anti-counterfeit enforcement mechanism to prevent the counterfeited goods from every channel. But why hire Wersel? Because you get the following benefits with Wersel's market monitoring services-",
    points: [
      {
        content: "",
        title: "Find the sellers that sell your products",
      },
      {
        content: "",
        title: "Locate your sellers",
      },
      {
        content: "",
        title: "History",
      },
      {
        content: "",
        title: "Spontaneous interface",
      },
      {
        content: "",
        title: "Ability to comprehend data",
      },
      {
        content: "",
        title: "Discount information",
      },
      {
        content: "",
        title: "Get notifications on your email",
      },
      {
        content: "",
        title: "Export pages",
      },
      {
        content: "",
        title: "Real-time chat assistance",
      },
    ],
    pointsSubText:
      "There are innumerable challenges that enterprises face when it comes to trademark infringement and counterfeit goods. Not only do these infringements cause the enterprises to lose a significant amount of revenue, but the brand reputation also suffers a downfall. But Wersel is the one-stop destination for all sorts of marketplace monitoring services you need.",
    howItWorksTitle: "Interested in a marketplace monitoring?",
    howItWorks:
      "Connect with us to get top notch marketplace monitoring services with the analytics experts at Wersel.",
    customers: [
      {
        name: "George",
        description: "Chief Executive Officer (CEO) - TSS",
        commentTitle: "They made My Business",
        comment:
          "We approach Datinfi based on their expirience in handling AI & ML Models, and the team did not dissappoint. They helped me to expand my business with more retailers and also increased 30% in my monthly recurring revenue",
        image: tss,
        id: 1,
      },
      {
        name: "Chris Shargunan",
        description: "Chief Technology Officer (CTO) - DriveX",
        commentTitle: "They made My Business",
        comment:
          "We developed a great rapport eith Datinfi and their dedication to our web portal development is evident in all aspects of the site. We appriciate their attention to detail and creative approach to bringing our new exhibit to life online",
        image: tWorldwide,
        id: 2,
      },
      {
        name: "Veles Nalliah",
        description: "BIIT Consulting",
        commentTitle: "They made My Business",
        comment:
          "Well! Wersel business app with analytics, becoming the core component of our business decision-making process. Datinfi has been a superior company to do the business with",
        image: drivex,
        id: 3,
      },
    ],
  }
  const {
    title,
    text,
    overviewTitle,
    overviewText,
    whyPartnerWerselTitle,
    whyPartnerWerselText,
    pointsSubText,
    services,
    points,
    howItWorks,
    howItWorksTitle,
    customers,
  } = datas
  return (
    <Layout withBrand slidePosition={0}>
      <SEO
        title="Prevent Marketplace Infringement With Wersel Market Monitoring Services"
        description="Our client-centric market monitoring services enable enterprises to maximize the respective market share and enhance revenue generation by eliminating counterfeit products from key marketplaces."
        keywords="marketplace monitoring, marketplace monitoring software, online marketplace monitoring tool"
        url="http://www.wersel.io/solutions/marketplace-monitoring"
      />
      <div className="services">
        <ServiceHeader title={title} text={text} image={bannerImage} />
        <OverviewSection
          overviewTitle={overviewTitle}
          overviewText={overviewText}
        />
        <ServicesSection services={services} />
        <OverviewSection
          overviewTitle={whyPartnerWerselTitle}
          overviewText={whyPartnerWerselText}
        />
        <PointsSection points={points} pointsSubText={pointsSubText} />
        <BookingSection
          howItWorksTitle={howItWorksTitle}
          howItWorks={howItWorks}
        />
        {/* <CustomerSection customers={customers} /> */}
        <RelatedArticles
          path={pathname}
          posts={data.posts.edges}
          title="Related Articles"
        />
      </div>
    </Layout>
  )
}
export const pageQuery = graphql`
  query MarketplaceMonitoring {
    posts: allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            title
            path
            description
          }
        }
      }
    }
  }
`
export default MarketplaceMonitoring
